import { OdysseyFloatingAlert } from '@barracuda/shared';
import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelectFromValidateEmail, useResetGlobalFloatingAlerts } from '@/store/useAppStore';

export const ValidatedEmailToast = () => {
  const fromValidateEmail = useSelectFromValidateEmail();
  const resetGlobalFloatingAlerts = useResetGlobalFloatingAlerts();
  const [showToast, setShowToast] = useState<boolean>(false);

  const { t } = useTranslation();

  useEffect(() => {
    if (fromValidateEmail) {
      setShowToast(true);
    }
  }, [fromValidateEmail]);

  const onCloseToast = useCallback(() => {
    setShowToast(false);
    resetGlobalFloatingAlerts(); // Reset the flag when toast is closed
  }, [resetGlobalFloatingAlerts]);

  return (
    <OdysseyFloatingAlert
      type='success'
      heading={t('verifyYourEmail.emailVerifiedTitle')}
      showAlert={showToast}
      floating
      dismissible={true}
      autoHide={true}
      onAlertClosed={onCloseToast}
    >
      {t('verifyYourEmail.emailVerifiedDescription')}
    </OdysseyFloatingAlert>
  );
};
